import React, { useState } from "react";
import { Link } from "react-router-dom";
import { X, Trash2, Minus, Plus, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";
import CheckoutModal from "./CheckoutModal";

const CartDrawer = () => {
  const { items, open, setOpen, removeItem, updateQty, subtotal, count } = useCart();
  const [checkout, setCheckout] = useState(false);

  return (
    <div className={`fixed inset-0 z-[90] ${open ? "" : "pointer-events-none"}`}>
      <div
        className={`absolute inset-0 bg-black/50 transition-opacity duration-300 ${open ? "opacity-100" : "opacity-0"}`}
        onClick={() => setOpen(false)}
      />
      <div
        className={`absolute right-0 top-0 flex h-full w-full max-w-md flex-col bg-white shadow-2xl transition-transform duration-300 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between border-b border-[#e6f0ea] px-5 py-4">
          <h2 className="font-display text-lg font-bold uppercase text-[#1B4332]">Your Basket ({count})</h2>
          <button onClick={() => setOpen(false)} aria-label="Close"><X size={22} className="text-[#1B4332]" /></button>
        </div>

        {items.length === 0 ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-4 p-8 text-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#f0f7f2]">
              <ShoppingBag className="text-[#2D6A4F]" size={28} />
            </div>
            <p className="text-[#6b7d72]">Your basket is empty.</p>
            <button
              onClick={() => setOpen(false)}
              className="rounded-full bg-[#2D6A4F] px-6 py-2.5 font-display text-sm font-semibold uppercase tracking-wider text-white transition hover:bg-[#1B4332]"
            >
              Start Shopping
            </button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto px-5 py-4">
              {items.map((i) => (
                <div key={i.id} className="mb-4 flex gap-3 border-b border-[#f0f5f2] pb-4">
                  <Link to={`/product/${i.slug}`} onClick={() => setOpen(false)} className="h-20 w-20 shrink-0 overflow-hidden rounded-xl bg-[#f3f8f4]">
                    <img src={i.image} alt={i.name} className="h-full w-full object-contain p-1" />
                  </Link>
                  <div className="flex flex-1 flex-col">
                    <div className="flex justify-between gap-2">
                      <span className="font-display text-sm font-semibold uppercase leading-tight text-[#1B2a21]">{i.name}</span>
                      <button onClick={() => removeItem(i.id)} aria-label="Remove"><Trash2 size={16} className="text-[#b0bdb4] transition hover:text-[#c1121f]" /></button>
                    </div>
                    <div className="mt-auto flex items-center justify-between">
                      <div className="flex items-center gap-2 rounded-full border border-[#dceadf] px-1">
                        <button onClick={() => updateQty(i.id, i.qty - 1)} className="p-1 text-[#2D6A4F]"><Minus size={14} /></button>
                        <span className="w-5 text-center text-sm font-semibold">{i.qty}</span>
                        <button onClick={() => updateQty(i.id, i.qty + 1)} className="p-1 text-[#2D6A4F]"><Plus size={14} /></button>
                      </div>
                      <span className="font-display font-bold text-[#1B4332]">£{(i.price * i.qty).toFixed(2)}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="border-t border-[#e6f0ea] p-5">
              <div className="mb-3 flex items-center justify-between">
                <span className="text-[#6b7d72]">Subtotal</span>
                <span className="font-display text-xl font-bold text-[#1B4332]">£{subtotal.toFixed(2)}</span>
              </div>
              <p className="mb-3 text-center text-xs text-[#8aa093]">Free UK shipping over £40 · Taxes calculated at checkout</p>
              <button onClick={() => { setOpen(false); setCheckout(true); }} className="w-full rounded-full bg-[#2D6A4F] py-3.5 font-display text-sm font-bold uppercase tracking-wider text-white transition hover:bg-[#1B4332]">
                Checkout
              </button>
            </div>
          </>
        )}
      </div>
      <CheckoutModal open={checkout} onClose={() => setCheckout(false)} />
    </div>
  );
};

export default CartDrawer;
